import debug from 'debug';
import { beginTask, endTask } from 'redux-nprogress';


const log = debug('huddle:store:actions:emailSettings');


// E-mail Preferences/Settings
export const USER_EMAIL_SETTINGS_KEY = 'emailSettings';
export const REQUEST = `${USER_EMAIL_SETTINGS_KEY}/REQUEST`;
export const RESPONSE = `${USER_EMAIL_SETTINGS_KEY}/RESPONSE`;
export const ERROR = `${USER_EMAIL_SETTINGS_KEY}/ERROR`;
export const VIEW = `${USER_EMAIL_SETTINGS_KEY}/view`;


export const fetchEmailSettingsThunk = () => async (dispatch, _, { api }) => {
  try {
    dispatch(beginTask());

    log('Fetching e-mail settings from API');
    dispatch({ type: REQUEST });

    const { getEmailSettings } = api.user;
    const response = await getEmailSettings();
    log('Received e-mail settings from API', response);
    dispatch({ type: RESPONSE, payload: response });
  } catch (err) {
    log('Received error while fetching e-mail settings from API', err);
    dispatch({ type: ERROR, error: err, });
  } finally {
    dispatch(endTask());
  }
};


export const updateEmailSettingsThunk = ({ email, receiveEmails }) =>
  async (dispatch, _, { api }) => {
    try {
      dispatch(beginTask());

      log('Updating e-mail settings on API');
      dispatch({ type: REQUEST });

      const { updateEmailSettings } = api.user;
      const response = await updateEmailSettings({ email, receiveEmails });
      log('Updated e-mail settings on API successfully', response);
      dispatch({ type: RESPONSE, payload: response });
    } catch (err) {
      log('Received error while updating e-mail settings on API', err);
      dispatch({ type: ERROR, error: err });
    } finally {
      dispatch(endTask());
    }
  };



// WEBPACK FOOTER //
// ./src/store/actions/emailSettings.js